export enum HHDSVideoEvent {
  loaded = "loaded",
  bufferStart = "bufferStart",
  play = "play",
  pause = "pause",
  ended = "ended",
  loop = "loop",
  timeUpdate = "timeUpdate",
}
